module.exports = "<div class=\"<%= container %>\">\r\n    <div gw-feature-toggler category=\"fb-sharing\" class=\"<%= content %>\">\r\n        {{ shareData.description }}\r\n        <div class=\"<%= button %>\" ng-click=\"share()\">\r\n            <i class=\"<%= logo %> fa fa-facebook-square\"></i>\r\n            <span class=\"<%= verb %>\"> {{ 'platform.facebook.Share' | translate }}</span>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/facebook/FacebookSharingDirective.html
// module id = 575
// module chunks = 0